// Pure function: builds the cellEvents map for one operator's quotes/inventories/release_dues.
// `validIsoSet` is the set of week ISO dates we care about — only events landing inside it are kept.

const QUOTE_PICKUP = {
  kind: "quote-pickup", eventType: "pickup", type: "Ritiro",
  color: "#002FA7", icon: "FileText", doc_type: "quote",
};
const QUOTE_DELIVERY = {
  kind: "quote-delivery", eventType: "delivery", type: "Consegna",
  color: "#059669", icon: "FileText", doc_type: "quote",
};

function makeQuoteEvent(q, base, isoDate) {
  return {
    ...base,
    number: q.number || "BOZZA",
    customer: q.customer_name,
    doc_id: q.id,
    navigateTo: `/quotes/${q.id}`,
    isStorage: q.delivery_type === "deposito",
    _date: isoDate,
  };
}

function makeInventoryEvent(inv, eventType, isoDate) {
  const isRelease = inv.inventory_type === "release";
  const isPickup = eventType === "inventory_pickup";
  const typeLabel = isRelease
    ? "Inv. Riconsegna"
    : (isPickup ? "Inv. Ritiro" : "Inv. Consegna");
  return {
    kind: isPickup ? "inv-pickup" : "inv-delivery",
    eventType, type: typeLabel,
    number: inv.number || "BOZZA",
    customer: inv.customer_name,
    doc_id: inv.id, doc_type: "inventory",
    navigateTo: `/inventories/${inv.id}`,
    color: isRelease ? "#D97706" : "#7C3AED",
    icon: "Package",
    _date: isoDate,
  };
}

function makeReleaseDueEvent(pf) {
  return {
    kind: "release-due", eventType: "release_due", type: "Riconsegna prevista",
    number: pf.number || "BOZZA",
    customer: pf.customer_name,
    doc_id: pf.id, doc_type: "proforma",
    navigateTo: `/proformas/${pf.id}`,
    color: "#EAB308", icon: "Receipt",
  };
}

export function buildOperatorCellEvents(operator, isoList) {
  const cells = {};
  isoList.forEach(iso => { cells[iso] = []; });

  (operator.quotes || []).forEach(q => {
    if (q.pickup_date && cells[q.pickup_date] !== undefined) {
      cells[q.pickup_date].push(makeQuoteEvent(q, QUOTE_PICKUP, q.pickup_date));
    }
    if (q.delivery_date && q.delivery_date !== q.pickup_date && cells[q.delivery_date] !== undefined) {
      cells[q.delivery_date].push(makeQuoteEvent(q, QUOTE_DELIVERY, q.delivery_date));
    }
  });

  (operator.inventories || []).forEach(inv => {
    if (inv.pickup_date && cells[inv.pickup_date] !== undefined) {
      cells[inv.pickup_date].push(makeInventoryEvent(inv, "inventory_pickup", inv.pickup_date));
    }
    if (inv.delivery_date && inv.delivery_date !== inv.pickup_date && cells[inv.delivery_date] !== undefined) {
      cells[inv.delivery_date].push(makeInventoryEvent(inv, "inventory_delivery", inv.delivery_date));
    }
  });

  (operator.release_dues || []).forEach(pf => {
    if (pf.payment_due_date && cells[pf.payment_due_date] !== undefined) {
      cells[pf.payment_due_date].push(makeReleaseDueEvent(pf));
    }
  });

  return cells;
}

export function buildAllCellEvents(operators, isoList) {
  const map = {};
  operators.forEach(op => {
    map[op.id] = buildOperatorCellEvents(op, isoList);
  });
  return map;
}

// Tailwind classes for heatmap based on event count (load color-coding)
export function heatmapClass(count) {
  if (count === 0) return "";
  if (count <= 2) return "bg-blue-50/40";
  if (count === 3) return "bg-amber-50/60";
  return "bg-red-50/70 ring-1 ring-red-200";
}
